export default __webpack_public_path__ + "static/media/t2s-logo.49d9b62d.webp";